import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { bulkCreateFulfillments as universalBulkCreateFulfillments, createFulfillment as universalCreateFulfillment, deleteFulfillment as universalDeleteFulfillment, listFulfillmentsForMultipleOrders as universalListFulfillmentsForMultipleOrders, listFulfillmentsForSingleOrder as universalListFulfillmentsForSingleOrder, updateFulfillment as universalUpdateFulfillment, } from './ecom-v1-fulfillments-order-fulfillments.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function listFulfillmentsForSingleOrder(httpClient) {
    return (orderId) => universalListFulfillmentsForSingleOrder(orderId, 
    // @ts-ignore
    { httpClient });
}
export function listFulfillmentsForMultipleOrders(httpClient) {
    return (orderIds) => universalListFulfillmentsForMultipleOrders(orderIds, 
    // @ts-ignore
    { httpClient });
}
export function createFulfillment(httpClient) {
    return (orderId, fulfillment) => universalCreateFulfillment(orderId, fulfillment, 
    // @ts-ignore
    { httpClient });
}
export function updateFulfillment(httpClient) {
    return (identifiers, options) => universalUpdateFulfillment(identifiers, options, 
    // @ts-ignore
    { httpClient });
}
export function deleteFulfillment(httpClient) {
    return (identifiers) => universalDeleteFulfillment(identifiers, 
    // @ts-ignore
    { httpClient });
}
export function bulkCreateFulfillments(httpClient) {
    return (ordersWithFulfillments) => universalBulkCreateFulfillments(ordersWithFulfillments, 
    // @ts-ignore
    { httpClient });
}
export const onFulfillmentsUpdated = EventDefinition('wix.ecom.v1.fulfillments_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.fulfillments.createdDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export { FulfillmentStatus, IdentityType, WebhookIdentityType, } from './ecom-v1-fulfillments-order-fulfillments.universal.js';
//# sourceMappingURL=ecom-v1-fulfillments-order-fulfillments.public.js.map